/**
 * en-GB messages added by shared reception task W-SR2 (docs/SHARED-RECEPTION-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts. UK English only.
 */
export const wSr2EnGB = {
    'srt.nav.label': 'Shared reception',
    'srt.page.title': 'Shared reception',
    'srt.page.description': 'Share one reception kiosk with other companies in your building. Your visitor records always stay in your own account.',
    'srt.empty': 'No shared reception invitations yet. When a building operator invites your organisation, the invitation appears here.',
    'srt.invitations.title': 'Invitations',
    'srt.invitations.description': 'Read what is shared before you decide. You can pause or leave later.',
    'srt.joined.title': 'Your shared receptions',
    'srt.joined.description': 'Buildings your organisation has joined.',
    'srt.past.title': 'Earlier',
    'srt.past.description': 'Invitations you declined and buildings you have left.',
    'srt.invite.from': 'Invited by {operator}',
    'srt.invite.address': 'Building address: {address}',
    'srt.invite.invitedAt': 'Invited on {date}',
    'srt.status.invited': 'Invited',
    'srt.status.active': 'Active',
    'srt.status.paused': 'Paused',
    'srt.status.leaving': 'Leaving',
    'srt.status.left': 'Left',
    'srt.status.declined': 'Declined',
    'srt.status.withdrawn': 'Withdrawn by the building',
    'srt.consent.shared.title': 'What is shared',
    'srt.consent.shared.description': 'Only these details leave your account, and only for fire safety.',
    'srt.consent.version': 'Statement version {version}',
    'srt.consent.privacy.title': 'Lines for your visitor privacy notice',
    'srt.consent.privacy.description': 'Add these to your own visitor privacy notice. They are suggestions, not legal advice.',
    'srt.consent.copy': 'Copy these lines',
    'srt.consent.copied': 'Copied to the clipboard.',
    'srt.consent.copyFailed': 'Could not copy. Select the text and copy it yourself.',
    'srt.accept.site': 'Which of your sites is in this building?',
    'srt.accept.siteHint': 'Only sites in the building’s time zone ({zone}) can join. Remote sites cannot.',
    'srt.accept.siteChoose': 'Choose a site',
    'srt.accept.noSites': 'None of your sites can join this building. A site must be in the building’s time zone and must not be a remote site.',
    'srt.accept.displayName': 'Name shown on the kiosk',
    'srt.accept.displayNameHint': 'Visitors see this in the list of companies. Up to 60 characters.',
    'srt.accept.button': 'Accept and join',
    'srt.accept.done': 'You have joined {building}.',
    'srt.decline.button': 'Decline',
    'srt.decline.confirm': 'Decline this invitation',
    'srt.decline.done': 'Invitation declined.',
    'srt.member.site': 'Site: {site}',
    'srt.member.displayName': 'Shown on the kiosk as: {name}',
    'srt.member.since': 'Joined on {date}',
    'srt.member.rename': 'Change name',
    'srt.member.rename.label': 'Name shown on the kiosk for {building}',
    'srt.member.rename.done': 'Name updated.',
    'srt.pause.button': 'Pause',
    'srt.pause.explain': 'Pausing takes your company off the kiosk list straight away. People already signed in can still sign out, and an evacuation still includes them.',
    'srt.pause.done': 'Paused. Your company no longer appears on the kiosk.',
    'srt.resume.button': 'Resume',
    'srt.resume.done': 'Resumed. Your company is back on the kiosk.',
    'srt.resume.outdated': 'The sharing statement has changed since you joined. Please read it and accept it to resume.',
    'srt.leave.button': 'Leave',
    'srt.leave.confirm': 'Leave this building',
    'srt.leave.explain': 'Your company disappears from the kiosk straight away. For up to 72 hours the kiosk can still send in sign-ins and sign-outs it stored while offline, then the link closes. Your visit records stay in your account.',
    'srt.leave.done': 'You are leaving {building}.',
    'srt.leaving.until': 'Wind-down ends by {time}. Until then queued sign-ins from the kiosk still arrive.',
    'srt.leaving.noTime': 'The link is closing. Queued sign-ins from the kiosk still arrive for a short time.',
    'srt.agreement.link': 'Read the data-sharing agreement',
    'srt.agreement.back': 'Back to shared reception',
    'srt.agreement.draftExplain': 'This agreement is a draft and has not yet been reviewed by a lawyer. Do not treat it as legal advice.',
    'srt.devices.badge': 'Shared: {building}',
    'srt.devices.limited': 'Shared kiosk link. Removing it stops only your company’s link; the building administrator manages the tablet itself.',
    'srt.devices.openPage': 'Shared reception settings',
    'srt.devices.unpairConfirm': 'Remove link for {name}',
    'srt.totals.title': 'Building evacuation in progress: {building}',
    'srt.totals.body': 'The whole building is being evacuated. These are combined counts for everyone in the building, with no names from other companies.',
    'srt.totals.unaccounted': 'Unaccounted: {count}',
    'srt.totals.safe': 'Safe: {count}',
    'srt.totals.missing': 'Missing: {count}',
    'srt.totals.offSite': 'Off site: {count}',
};
//# sourceMappingURL=w-sr2.js.map